/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// fixedボタンの表示制御
window.addEventListener('scroll', function () {
    if (600 < window.scrollY) {
        document.getElementById('bottom_fixed_wrapper').style.transition = '.3s';
        document.getElementById('bottom_fixed_wrapper').style.visibility = 'visible';
        document.getElementById('bottom_fixed_wrapper').style.opacity = '1';
    } else {
        document.getElementById('bottom_fixed_wrapper').style.transition = 'unset';
        document.getElementById('bottom_fixed_wrapper').style.visibility = 'hidden';
        document.getElementById('bottom_fixed_wrapper').style.opacity = '0';
    }
});

$(function () {
    $('.ac-label').click(function (event) {
        $(this).next('div').slideToggle();
        $(this).find('.icon').toggleClass('open');
    });
});

$(function () {
    $('.ac-label2').click(function (event) {
        $(this).next('div').slideToggle();
        $(this).find('.icon2').toggleClass('open');
    });
});

$(function () {
    $('a[href^="#"]').click(function () {
        var speed = 500;
        var href = $(this).attr('href');
        var target = $(href == '#' || href == '' ? 'html' : href);
        var position = target.offset().top - 100; // ここで50pxを減算
        $('html, body').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });
});

// コーディネートページ - スライド
jQuery(document).ready(function ($) {
    function initializeSwiper(selector) {
        var $swiperContainer = $(selector);
        var slidesCount = $swiperContainer.find('.swiper-slide').length;

        if (slidesCount <= 1) {
            $swiperContainer.find('.swiper-pagination, .swiper-button-next, .swiper-button-prev').hide();
        } else {
            new Swiper(selector, {
                loop: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                speed: 1000,
                // autoplay: {
                //     delay: 4000,
                //     disableOnInteraction: false,
                // },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 1,
            });
        }
    }

    initializeSwiper('#coordinate-recommend-main');
    initializeSwiper('#coordinate-recommend-gallery');
});

// コーディネートページ：ギャラリー部分展開ボタン
// jQuery(document).ready(function ($) {
//     function updateGallery($gallery, itemsPerPage) {
//         $gallery.find('.gallery-item').each(function (index) {
//             if (index < itemsPerPage) {
//                 $(this).show().removeClass('hidden-photo');
//             } else {
//                 $(this).hide().addClass('hidden-photo');
//             }
//         });
//     }

//     function checkWindowSize($gallery, itemsPerPagePC, itemsPerPageSP) {
//         if ($(window).width() <= 768) {
//             updateGallery($gallery, itemsPerPageSP);
//         } else {
//             updateGallery($gallery, itemsPerPagePC);
//         }
//     }

//     function debounce(func, wait) {
//         let timeout;
//         return function (...args) {
//             const context = this;
//             clearTimeout(timeout);
//             timeout = setTimeout(() => func.apply(context, args), wait);
//         };
//     }

//     $('.c-btn__gallery-text').each(function () {
//         var sectionId = $(this).data('section-id');
//         var $gallery = $('#coordinate-recommend-' + sectionId + ' .p-coordinate__recommend-gallery__list');
//         var $gradient = $('#gradient-' + sectionId);
//         var $moreBtn = $('#more-btn-' + sectionId);
//         var $listGradient = $('#coordinate-recommend-' + sectionId + ' .p-coordinate__recommend-gallery__list-gradient');
//         var itemsPerPagePC = 8;
//         var itemsPerPageSP = 6;
//         var totalImages = $gallery.find('.gallery-item').length;
//         var isExpanded = false;

//         function initialCheck() {
//             checkWindowSize($gallery, itemsPerPagePC, itemsPerPageSP);
//             if (totalImages <= itemsPerPagePC) {
//                 $gradient.hide();
//                 $moreBtn.hide();
//             } else {
//                 $gradient.show();
//                 $moreBtn.show();
//             }
//         }

//         initialCheck();

//         $(window).on(
//             'resize',
//             debounce(function () {
//                 checkWindowSize($gallery, itemsPerPagePC, itemsPerPageSP);
//             }, 200)
//         );

//         $(this).on('click', function (e) {
//             e.preventDefault();
//             if (!isExpanded) {
//                 $gallery.find('.hidden-photo').slideDown('slow').removeClass('hidden-photo');
//                 $(this).text('閉じる');
//                 $moreBtn.addClass('is-expanded');
//                 $gradient.fadeOut('slow');
//                 $listGradient.fadeOut('slow');
//             } else {
//                 var itemsPerPage = $(window).width() <= 768 ? itemsPerPageSP : itemsPerPagePC;
//                 $gallery
//                     .find('.gallery-item')
//                     .slice(itemsPerPage)
//                     .slideUp('slow', function () {
//                         $(this).addClass('hidden-photo');
//                     });
//                 $(this).text('もっと見る');
//                 $moreBtn.removeClass('is-expanded');
//                 $gradient.fadeIn('slow');
//                 $listGradient.fadeIn('slow');
//             }
//             isExpanded = !isExpanded;
//         });
//     });
// });

jQuery(document).ready(function ($) {
    var itemsPerPagePC = 8;
    var itemsPerPageSP = 6;
    var isExpanded = false;

    function updateGallery($gallery, itemsPerPage) {
        if (!isExpanded) {
            $gallery.find('.gallery-item').each(function (index) {
                if (index < itemsPerPage) {
                    $(this).show().removeClass('hidden-photo');
                } else {
                    $(this).hide().addClass('hidden-photo');
                }
            });
        }
    }

    function checkWindowSize($gallery) {
        var itemsPerPage = $(window).width() <= 768 ? itemsPerPageSP : itemsPerPagePC;
        updateGallery($gallery, itemsPerPage);
    }

    $('.c-btn__gallery-text').each(function () {
        var sectionId = $(this).data('section-id');
        var $gallery = $('#coordinate-recommend-' + sectionId + ' .p-coordinate__recommend-gallery__list');
        var $gradient = $('#gradient-' + sectionId);
        var $moreBtn = $('#more-btn-' + sectionId);
        var $listGradient = $('#coordinate-recommend-' + sectionId + ' .p-coordinate__recommend-gallery__list-gradient');

        // 初期表示の設定
        checkWindowSize($gallery);

        if ($gallery.find('.gallery-item').length <= itemsPerPagePC) {
            $gradient.hide();
            $moreBtn.hide();
        } else {
            $gradient.show();
            $moreBtn.show();
        }

        // リサイズイベント
        $(window).on('resize', function () {
            checkWindowSize($gallery);
        });

        // クリックイベント
        $(this).on('click', function (e) {
            e.preventDefault();
            $('.hidden-photo').slideToggle('slow');
            if (!isExpanded) {
                $(this).text('閉じる');
                $gradient.fadeOut('slow');
                $listGradient.fadeOut('slow');
                $moreBtn.addClass('is-expanded');
            } else {
                $(this).text('もっと見る');
                $gradient.fadeIn('slow');
                $listGradient.fadeIn('slow');
                $moreBtn.removeClass('is-expanded');
            }
            isExpanded = !isExpanded;
        });
    });
});

(function () {
    if (window.location.pathname !== '/pages/hanayome-guide') return;

    function fillHanayomeGuidePhotos() {
        if (window.tksGuidePhotosFilled) return;
        window.tksGuidePhotosFilled = true;

        var photos = {
            'slot-type-irouchikake': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_043_img01_600x.jpg?v=1677556016', alt: '赤黒鳳凰の色打掛', pos: '50% 42%' },
            'slot-type-hikifurisode': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_010_img01_600x.jpg?v=1681728590', alt: '蝶に花の引き振袖', pos: '50% 44%' },
            'slot-type-montsuki': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/15263-1_600x.jpg?v=1718254347', alt: '黒羽二重と仙台平の紋付袴', pos: '50% 45%' },
            'slot-pc-spring-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_117_img01_600x.jpg?v=1677553668', alt: '珊瑚色に近い華やかな色打掛', pos: '50% 44%' },
            'slot-pc-spring-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/20230525_0658re_600x.jpg?v=1701679804', alt: 'あたたかな白みの白無垢', pos: '50% 44%' },
            'slot-pc-spring-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-5-1.jpg?v=13948451832690944301', alt: '若草色を感じる花柄の和装コーディネート', pos: '50% 45%' },
            'slot-pc-summer-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/bluebase-14-1.jpg?v=17858835748340274415', alt: '藤色や水色に近い淡色打掛', pos: '50% 45%' },
            'slot-pc-summer-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/20230525_0030re_600x.jpg?v=1701743604', alt: '青みを感じる純白の白無垢', pos: '50% 44%' },
            'slot-pc-summer-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/bluebase-2-1.jpg?v=12735914278900763741', alt: '淡紅と桜鼠を思わせるやわらかな一着', pos: '50% 45%' },
            'slot-pc-autumn-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-8-1.jpg?v=16968764564255576983', alt: '金茶と深緑を感じる色打掛', pos: '50% 45%' },
            'slot-pc-autumn-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/89771-2_600x.jpg?v=1716195400', alt: '生成りと象牙色を感じる白無垢', pos: '50% 44%' },
            'slot-pc-autumn-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-11-1.jpg?v=3538094070293760757', alt: '臙脂と古典文様の一着', pos: '50% 45%' },
            'slot-pc-winter-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_156_img01_600x.jpg?v=1677561310', alt: '朱赤と瑠璃を感じる色打掛', pos: '50% 45%' },
            'slot-pc-winter-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/re202300615_0475_600x.jpg?v=1701742418', alt: '青みの強い純白の白無垢', pos: '50% 44%' },
            'slot-pc-winter-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_006_img01_600x.jpg?v=1681728494', alt: '黒引き振袖に近い深色の引き振袖', pos: '50% 44%' },
            'slot-v-kominka': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-set-3-1.jpg?v=2243025443102531664', alt: '古民家や町家に合う深みのある和装コーディネート', pos: '50% 45%' },
            'slot-vd-kominka-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/89172_2_600x.jpg?v=1716799030', alt: '生成りの白無垢と古民家に合う装い', pos: '50% 44%' },
            'slot-vd-kominka-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-12-1.jpg?v=6846182812951190985', alt: '金茶と深緑の色打掛', pos: '50% 45%' },
            'slot-vd-kominka-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_008_img01_600x.jpg?v=1679154227', alt: '町家に合う黒引き振袖', pos: '50% 44%' },
            'slot-v-guesthouse': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/bluebase-set-4-1.jpg?v=16052496460854991227', alt: 'ゲストハウスや邸宅の自然光に映える和装', pos: '50% 45%' },
            'slot-vd-guesthouse-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/re202300615_0364_600x.jpg?v=1701744788', alt: '白壁に映える清楚な白無垢', pos: '50% 44%' },
            'slot-vd-guesthouse-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/bluebase-7-1.jpg?v=4783978734554508595', alt: '藤色や水色の淡色打掛', pos: '50% 45%' },
            'slot-vd-guesthouse-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/bluebase-3-1.jpg?v=12379773209210942792', alt: 'くすみピンクを感じる淡色の一着', pos: '50% 45%' },
            'slot-v-hall': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/20230525_0113re_600x.jpg?v=1701678226', alt: '専門式場や神殿に合う正統な白無垢', pos: '50% 44%' },
            'slot-vd-hall-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/re202300615_0086_600x.jpg?v=1701742612', alt: '神殿に映える正統な白無垢', pos: '50% 44%' },
            'slot-vd-hall-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_151_img01_600x.jpg?v=1677560973', alt: '赤と金が映える色打掛', pos: '50% 42%' },
            'slot-vd-hall-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/20230525_08071_600x.jpg?v=1701679804', alt: '綿帽子や角隠しを思わせる白無垢の装い', pos: '50% 44%' },
            'slot-v-hotel': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_165_img01_600x.jpg?v=1677562139', alt: 'ホテルや宴会場に映える華やかな和装', pos: '50% 45%' },
            'slot-vd-hotel-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_180_img01_600x.jpg?v=1677566132', alt: '朱赤と瑠璃の色打掛', pos: '50% 45%' },
            'slot-vd-hotel-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_043_img02_600x.jpg?v=1677556015', alt: '大柄と金彩が華やかな一着', pos: '50% 45%' },
            'slot-vd-hotel-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_006_img02_600x.jpg?v=1681728494', alt: '宴会場に映える黒引き振袖', pos: '50% 45%' },
            'slot-vd-garden-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/20230525_0296re_600x.jpg?v=1701743234', alt: '緑に映える白無垢', pos: '50% 44%' },
            'slot-vd-garden-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_115_img01_600x.jpg?v=1677553718', alt: '朱や珊瑚の色打掛', pos: '50% 44%' },
            'slot-vd-garden-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-3-1.jpg?v=14828019589699955996', alt: '花柄と淡色の一着', pos: '50% 45%' },
            'slot-ko-1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/re202300615_0487_600x.jpg?v=1701742418', alt: '白無垢に合わせる綿帽子のイメージ', pos: '50% 44%' },
            'slot-ko-2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/20230525_0417re_600x.jpg?v=1701743234', alt: '白無垢に合わせる角隠しのイメージ', pos: '50% 44%' },
            'slot-ko-3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-set-1-2.jpg?v=14520985626686667945', alt: '筥迫を含む胸元の小物コーディネート', pos: '50% 52%' },
            'slot-ko-4': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-set-2-2.jpg?v=4454768823967086758', alt: '懐剣を含む花嫁小物のコーディネート', pos: '50% 52%' },
            'slot-ko-5': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-16-2.jpg?v=6825683855979961112', alt: '末広に合う扇面柄の和装', pos: '50% 52%' },
            'slot-ko-6': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_010_img02_600x.jpg?v=1681728597', alt: '引き振袖の帯まわり', pos: '50% 52%' },
            'slot-ko-7': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/bluebase-set-1-2.jpg?v=15443582969674260873', alt: '半衿と伊達衿を含む衿元コーディネート', pos: '50% 52%' },
            'slot-ko-8': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-set-1-3.jpg?v=9803340630193275392', alt: '花嫁の髪飾りのイメージ', pos: '50% 52%' },
            'slot-g1': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/20230525_0030re_600x.jpg?v=1701743604', alt: '白無垢', pos: '50% 44%' },
            'slot-g2': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_043_img01_600x.jpg?v=1677556016', alt: '色打掛', pos: '50% 42%' },
            'slot-g3': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_010_img01_600x.jpg?v=1681728590', alt: '引振袖', pos: '50% 44%' },
            'slot-g4': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/yellowbase-set-1-2.jpg?v=14520985626686667945', alt: '和装小物', pos: '50% 52%' },
            'slot-g5': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/tks-guide-hero-shiromuku.jpg?v=13834286764520882764', alt: '髪飾り', pos: '50% 28%' },
            'slot-g7': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_117_img01_600x.jpg?v=1677553668', alt: '華やかな色打掛', pos: '50% 44%' },
            'slot-g8': { src: 'https://www.the-kimonoshop.jp/cdn/shop/products/kimono_010_img02_600x.jpg?v=1681728597', alt: '引振袖の後ろ姿', pos: '50% 45%' },
            'slot-g9': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/tks-guide-venue-garden.jpg?v=4044919617927866866', alt: 'ロケーション撮影の和装', pos: '60% 55%' },
            'slot-g10': { src: 'https://www.the-kimonoshop.jp/cdn/shop/files/tks-guide-oiro-shiromuku.jpg?v=10435584600453098480', alt: '挙式シーンの白無垢', pos: '50% 40%' }
        };

        Object.keys(photos).forEach(function (id) {
            var slot = document.getElementById(id);
            var photo = photos[id];
            var img;

            if (!slot) return;

            img = document.createElement('img');
            img.src = photo.src;
            img.alt = photo.alt;
            img.loading = 'lazy';
            img.style.objectPosition = photo.pos || '50% 50%';
            slot.classList.remove('ph');
            slot.replaceChildren(img);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fillHanayomeGuidePhotos);
    } else {
        fillHanayomeGuidePhotos();
    }
})();

(function () {
    if (window.location.pathname !== '/pages/hanayome-guide') return;

    function setupGuideGalleryFancybox() {
        var gallery = document.querySelector('.gallery .g-tiles');
        var observer;

        if (!gallery || window.tksGuideGalleryFancyboxReady) return;
        window.tksGuideGalleryFancyboxReady = true;

        function prepareItems() {
            gallery.querySelectorAll('.slot').forEach(function (slot) {
                var img = slot.querySelector('img');
                var link;

                if (!img) return;

                link = slot.querySelector('a[data-fancybox="hanayome-guide-gallery"]');
                if (link && link.contains(img)) {
                    link.href = img.currentSrc || img.src;
                    link.dataset.caption = img.alt || '';
                    return;
                }

                link = document.createElement('a');
                link.href = img.currentSrc || img.src;
                link.dataset.fancybox = 'hanayome-guide-gallery';
                link.dataset.caption = img.alt || '';
                link.setAttribute('aria-label', '画像を拡大表示');

                slot.replaceChildren(link);
                link.appendChild(img);
            });
        }

        function bindFancybox() {
            var selector = '[data-fancybox="hanayome-guide-gallery"]';

            if (!window.Fancybox) return;
            if (typeof window.Fancybox.unbind === 'function') {
                window.Fancybox.unbind(selector);
            }
            window.Fancybox.bind(selector, {
                Hash: false
            });
        }

        prepareItems();
        bindFancybox();

        observer = new MutationObserver(function () {
            prepareItems();
            if (window.Fancybox) bindFancybox();
        });
        observer.observe(gallery, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupGuideGalleryFancybox);
    } else {
        setupGuideGalleryFancybox();
    }
})();
